module.exports = __webpack_public_path__ + "img/rz_02.457d9f26.png";